import React, {ReactNode, useState} from 'react';
import Lightbox, {ViewCallbackProps} from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import './ImageGallery.css';

export interface ImageItem {
    src: string
    title: string | ReactNode
    description: string
    alt?: string
}

interface ImageGalleryProps {
    images: ImageItem[]
}

interface MappedImageItem {
    src: string;
    description: string;
    title: string | ReactNode;
    thumbnailURL: string
    alt: string
}

const THUMBNAIL_MAX_WIDTH = 120;
const THUMBNAIL_MAX_HEIGHT = 100;

const ImageGallery = (props: ImageGalleryProps) => {

    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const images: MappedImageItem[] = props.images.map(image => {
        return {
            src: image.src + "?maxWidth=2048&maxHeight=2048",
            thumbnailURL: image.src + `?maxWidth=${THUMBNAIL_MAX_WIDTH}&maxHeight=${THUMBNAIL_MAX_HEIGHT}`,
            title: image.title,
            description: image.description,
            alt: (image.alt)
                ? image.alt
                : (typeof image.title === 'string')
                    ? image.title
                    : 'Image',
        };
    });

    return (
        <>
            <div className="thumbnail-container">
                {images.map((image, idx) => {
                    return (
                        <div key={`img${idx}`} className="photo-container">
                            <img
                                key={idx}
                                src={image.thumbnailURL}
                                className='lightbox-img-thumbnail'
                                style={{maxWidth: `${THUMBNAIL_MAX_WIDTH}px`, maxHeight: `${THUMBNAIL_MAX_HEIGHT}px`}}
                                alt={image.alt}
                                onClick={() => setSelectedIndex(idx)} />
                            <p>{image.title}</p>
                        </div>
                    )
                })}
            </div>

            <Lightbox
                plugins={[
                    Captions,
                    Download,
                    Zoom
                ]}
                slides={images}
                open={selectedIndex !== null}
                index={selectedIndex ?? 0}
                on={{
                    view: (x: ViewCallbackProps) => {
                        // setRotation(0);
                        setSelectedIndex(x.index);
                    }
                }}
                close={() =>
                    setSelectedIndex(null)
                }
            />
        </>
    )

}

export default ImageGallery;
